(function (angular) {
	'use strict';

	angular.module('PinMeTo.edit').component('pmtEdit', {
		templateUrl: 'pmtShared/edit/pmtEdit.html',
		controller: Edit,
		bindings: {
			value: '=',
			title: '<'
		}
	});

	function Edit() {
		var $ctrl = this;

		$ctrl.tmp = '';

		$ctrl.showEdit = false;
		$ctrl.onClick = function () {
			$ctrl.tmp = $ctrl.value;
			$ctrl.showEdit = true;
		};

		$ctrl.save = function () {
			$ctrl.showEdit = false;
			$ctrl.value = $ctrl.tmp;
		};
	}
})(window.angular);
